<div class="signup-wrapper" [class.rtl-content]="textDirection === 'rtl'">
  <div class="signup-container">
    <div class="header">
      <h2>{{ 'PARTNER_SIGNUP.TITLE' | translate }}</h2>
      <p class="subtitle">{{ 'PARTNER_SIGNUP.SUBTITLE' | translate }}</p>
    </div>

    <p-stepper [(activeStep)]="activeStep">
      <!-- Step 1: Application Details (Required) -->
      <p-stepperPanel>
        <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
          <button
            (click)="onStepHeaderClick(0, onClick)"
            class="partner-stepper-btn"
            [class.active]="activeStep === 0"
            [class.completed]="interestRequestId"
            [class.locked]="!canNavigateToStep(0)"
          >
            <span class="step-icon">
              <i [class]="interestRequestId ? 'pi pi-check' : 'pi pi-building'"></i>
            </span>
            <span class="step-label">{{
              'PARTNER_SIGNUP.STEP_APPLICATION_DETAILS' | translate
            }}</span>
          </button>
        </ng-template>

        <ng-template pTemplate="content">
          <form [formGroup]="partnerRequestForm">
            <!-- Business Information Section -->
            <div class="partner-form-section">
              <h3 class="partner-section-title">
                {{ 'PARTNER_SIGNUP.SECTION_BUSINESS_DETAILS' | translate }}
              </h3>

              <div class="form-row">
                <div class="form-field">
                  <label for="businessName" class="partner-field-label"
                    >{{ 'BUSINESS_NAME' | translate }} <span class="required">*</span></label
                  >
                  <input
                    id="businessName"
                    pInputText
                    formControlName="businessName"
                    placeholder="{{ 'BUSINESS_NAME' | translate }}"
                  />
                  @if (
                    partnerRequestForm.get('businessName')?.touched &&
                    partnerRequestForm.get('businessName')?.invalid
                  ) {
                    <small class="partner-error-text">
                      {{ 'VALIDATION.BUSINESS_NAME_REQUIRED' | translate }}
                    </small>
                  }
                </div>

                <div class="form-field">
                  <label for="businessNameArabic" class="partner-field-label"
                    >{{ 'BUSINESS_NAME_ARABIC' | translate }}
                  </label>
                  <input
                    id="businessNameArabic"
                    pInputText
                    formControlName="businessNameArabic"
                    placeholder="{{ 'BUSINESS_NAME_ARABIC' | translate }}"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-field">
                  <label for="country" class="partner-field-label"
                    >{{ 'SELECT_COUNTRY' | translate }} <span class="required">*</span></label
                  >
                  <p-dropdown
                    inputId="country"
                    formControlName="country"
                    [options]="countries"
                    [optionLabel]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                    placeholder="{{ 'SELECT_COUNTRY' | translate }}"
                    [filter]="true"
                    [filterBy]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-row">
                <div class="form-field">
                  <label for="busines_type" class="partner-field-label"
                    >{{ 'BUSINESS_TYPE' | translate }} <span class="required">*</span></label
                  >
                  <p-dropdown
                    inputId="busines_type"
                    formControlName="busines_type"
                    [options]="businessType"
                    [optionLabel]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                    placeholder="{{ 'BUSINESS_TYPE' | translate }}"
                  >
                  </p-dropdown>
                </div>

                @if (isNotInStore) {
                  <div class="form-field">
                    <label for="platform" class="partner-field-label">{{
                      'PLATFORM' | translate
                    }}</label>
                    <p-dropdown
                      inputId="platform"
                      formControlName="platform"
                      [options]="platForms"
                      [optionLabel]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                      placeholder="{{ 'PLATFORM' | translate }}"
                    >
                    </p-dropdown>
                  </div>
                }
              </div>

              @if (isNotInStore) {
                <div class="form-row">
                  <div class="form-field full-width">
                    <label for="webURL" class="partner-field-label">{{
                      'WEB_URL' | translate
                    }}</label>
                    <input
                      id="webURL"
                      pInputText
                      formControlName="webURL"
                      placeholder="https://example.com"
                    />
                  </div>
                </div>
              }

              @if (isOtherPlatform) {
                <div class="form-row">
                  <div class="form-field full-width">
                    <label for="otherPlatfom" class="partner-field-label">{{
                      'OTHER_PLATFORM' | translate
                    }}</label>
                    <input
                      id="otherPlatfom"
                      pInputText
                      formControlName="otherPlatfom"
                      placeholder="{{ 'OTHER_PLATFORM' | translate }}"
                    />
                  </div>
                </div>
              }
            </div>

            <!-- Contact Information Section -->
            <div class="partner-form-section">
              <h3 class="partner-section-title">{{ 'CONTACT_INFO' | translate }}</h3>

              <div class="form-row">
                <div class="form-field">
                  <label for="contactPersonFullName" class="partner-field-label"
                    >{{ 'CONTACT_PERSON' | translate }} <span class="required">*</span></label
                  >
                  <input
                    id="contactPersonFullName"
                    pInputText
                    formControlName="contactPersonFullName"
                    placeholder="{{ 'CONTACT_PERSON' | translate }}"
                  />
                  @if (
                    partnerRequestForm.get('contactPersonFullName')?.touched &&
                    partnerRequestForm.get('contactPersonFullName')?.invalid
                  ) {
                    <small class="partner-error-text">
                      {{ 'VALIDATION.CONTACT_PERSON_REQUIRED' | translate }}
                    </small>
                  }
                </div>

                <div class="form-field">
                  <label for="emailAddress" class="partner-field-label"
                    >{{ 'BUSINESS_EMAIL' | translate }} <span class="required">*</span></label
                  >
                  <input
                    id="emailAddress"
                    pInputText
                    formControlName="emailAddress"
                    placeholder="email@example.com"
                    type="email"
                  />
                  @if (
                    partnerRequestForm.get('emailAddress')?.touched &&
                    partnerRequestForm.get('emailAddress')?.invalid
                  ) {
                    <small class="partner-error-text">
                      {{ 'VALIDATION.EMAIL_REQUIRED' | translate }}
                    </small>
                  }
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label for="mobileNumber" class="partner-field-label"
                    >{{ 'PHONE_NUMBER' | translate }} <span class="required">*</span></label
                  >
                  <div class="phone-input">
                    <span class="country-code">+965</span>
                    <input
                      id="mobileNumber"
                      pInputText
                      formControlName="mobileNumber"
                      placeholder="XXXXXXXX"
                      maxlength="8"
                    />
                  </div>
                  @if (
                    partnerRequestForm.get('mobileNumber')?.touched &&
                    partnerRequestForm.get('mobileNumber')?.invalid
                  ) {
                    <small class="partner-error-text">
                      {{ 'VALIDATION.PHONE_INVALID' | translate }}
                    </small>
                  }
                </div>
              </div>
            </div>

            <!-- Terms & Submit -->
            <div class="form-actions">
              <div class="terms-text">
                <span translate>TERM_ACCEPTING</span>&nbsp;<span
                  class="link"
                  (click)="showDialog(true)"
                  tabindex="0"
                  role="button"
                  >{{ 'TERM_OF_USE' | translate }}</span
                >&nbsp;<span translate>AND</span>&nbsp;<span
                  class="link"
                  (click)="showDialog(false)"
                  tabindex="0"
                  role="button"
                  >{{ 'PRIVACY_POLICY' | translate }}</span
                >
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="onSubmitStep1()"
                [disabled]="!isStep1Valid() || submitting"
              >
                @if (submitting) {
                  <i class="pi pi-spin pi-spinner"></i>
                }
                {{
                  submitting
                    ? ('PARTNER_SIGNUP.BTN_SUBMITTING' | translate)
                    : ('PARTNER_SIGNUP.BTN_CONTINUE' | translate)
                }}
              </button>
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- Step 2: Additional Details (Optional) -->
      <p-stepperPanel>
        <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
          <button
            (click)="onStepHeaderClick(1, onClick)"
            class="partner-stepper-btn"
            [class.active]="activeStep === 1"
            [class.locked]="!canNavigateToStep(1)"
          >
            <span class="step-icon">
              <i class="pi pi-id-card"></i>
            </span>
            <span class="step-label">{{
              'PARTNER_SIGNUP.STEP_ADDITIONAL_DETAILS' | translate
            }}</span>
          </button>
        </ng-template>

        <ng-template pTemplate="content">
          <!-- Info Banner -->
          <div class="partner-info-banner">
            <i class="pi pi-info-circle"></i>
            <span>
              <strong>{{ 'PARTNER_SIGNUP.STEP2_INFO_BANNER' | translate }}</strong
              >, {{ 'PARTNER_SIGNUP.STEP2_INFO_BANNER_2' | translate }}
              <strong>{{ 'PARTNER_SIGNUP.SPEED_UP_REVIEW' | translate }}</strong
              >.
            </span>
          </div>

          <form [formGroup]="partnerRequestForm">
            <!-- Brand & Category Section -->
            <div class="partner-form-section">
              <h3 class="partner-section-title">
                {{ 'PARTNER_SIGNUP.SECTION_BRAND_CATEGORY' | translate }}
              </h3>

              <div class="form-row">
                <div class="form-field">
                  <label for="brandName" class="partner-field-label">{{
                    'BRAND_NAME' | translate
                  }}</label>
                  <input
                    id="brandName"
                    pInputText
                    formControlName="brandName"
                    placeholder="{{ 'BRAND_NAME' | translate }}"
                  />
                </div>

                <div class="form-field">
                  <label for="category" class="partner-field-label">{{
                    'CATERGORY' | translate
                  }}</label>
                  <p-dropdown
                    inputId="category"
                    formControlName="category"
                    [options]="categories"
                    [optionLabel]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                    placeholder="{{ 'CATERGORY' | translate }}"
                    [filter]="true"
                    [filterBy]="textDirection === 'rtl' ? 'nameAr' : 'nameEn'"
                  >
                  </p-dropdown>
                </div>
              </div>

              @if (isOtherIndustry) {
                <div class="form-row">
                  <div class="form-field full-width">
                    <label for="otherIndustry" class="partner-field-label">{{
                      'OTHER_CATERGORY' | translate
                    }}</label>
                    <input
                      id="otherIndustry"
                      pInputText
                      formControlName="otherIndustry"
                      placeholder="{{ 'OTHER_CATERGORY' | translate }}"
                    />
                  </div>
                </div>
              }
            </div>

            <!-- Banking Information Section -->
            <div class="partner-form-section">
              <h3 class="partner-section-title">
                {{ 'PARTNER_SIGNUP.SECTION_BANKING_INFO' | translate }}
              </h3>

              <div class="form-row">
                <div class="form-field">
                  <label for="bankName" class="partner-field-label">{{
                    'BANK_NAME' | translate
                  }}</label>
                  <input
                    id="bankName"
                    pInputText
                    formControlName="bankName"
                    placeholder="{{ 'BANK_NAME' | translate }}"
                  />
                </div>

                <div class="form-field">
                  <label for="bankAccountHolderName" class="partner-field-label">{{
                    'ACCOUNT_HOLDER_NAME' | translate
                  }}</label>
                  <input
                    id="bankAccountHolderName"
                    pInputText
                    formControlName="bankAccountHolderName"
                    placeholder="{{ 'ACCOUNT_HOLDER_NAME' | translate }}"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label for="bankAccountNumber" class="partner-field-label">{{
                    'ACCOUNT_NUMBER' | translate
                  }}</label>
                  <input
                    id="bankAccountNumber"
                    pInputText
                    formControlName="bankAccountNumber"
                    placeholder="{{ 'ACCOUNT_NUMBER' | translate }}"
                  />
                </div>

                <div class="form-field">
                  <label for="iban" class="partner-field-label">{{ 'IBAN' | translate }}</label>
                  <input
                    id="iban"
                    pInputText
                    formControlName="iban"
                    placeholder="{{ 'IBAN' | translate }}"
                  />
                </div>
              </div>
            </div>

            <!-- Branding Section (matching edit-merchant pattern) -->
            <div class="partner-form-section">
              <h3 class="partner-section-title">
                {{ 'PARTNER_SIGNUP.SECTION_BRANDING' | translate }}
              </h3>

              <div class="form-row">
                <div class="form-field">
                  <label for="logoUpload" class="partner-field-label">{{
                    'PARTNER_SIGNUP.LOGO_UPLOAD' | translate
                  }}</label>
                  <div class="partner-image-upload">
                    @if (logoFile && !partnerRequestForm.get('logoFile')?.hasError('fileType')) {
                      <div class="image-preview">
                        <img [src]="logoFile" alt="Logo preview" />
                      </div>
                    }
                    @if (!logoFile || partnerRequestForm.get('logoFile')?.hasError('fileType')) {
                      <div class="upload-placeholder">
                        <i class="pi pi-image"></i>
                        <span>{{ 'PARTNER_SIGNUP.NO_LOGO' | translate }}</span>
                      </div>
                    }
                    <input
                      type="file"
                      id="logoUpload"
                      formControlName="logoFile"
                      accept=".jpeg,.png"
                      (change)="onFileSelected($event, 'logoFile')"
                      hidden
                    />
                    <label for="logoUpload" class="partner-upload-btn">
                      <i class="pi pi-upload"></i> {{ 'PARTNER_SIGNUP.UPLOAD' | translate }}
                    </label>
                  </div>
                  <small class="partner-hint-text">PNG or JPG, max 500KB</small>
                  @if (partnerRequestForm.get('logoFile')?.hasError('fileType')) {
                    <small class="partner-error-text">
                      {{ partnerRequestForm.get('logoFile')?.getError('fileType')?.fileType }}
                    </small>
                  }
                  @if (partnerRequestForm.get('logoFile')?.hasError('fileSizeExceeded')) {
                    <small class="partner-error-text">
                      {{
                        partnerRequestForm.get('logoFile')?.getError('fileSizeExceeded')
                          ?.fileSizeExceeded
                      }}
                    </small>
                  }
                </div>

                <div class="form-field">
                  <label for="featuredUpload" class="partner-field-label">{{
                    'PARTNER_SIGNUP.FEATURED_IMAGE_UPLOAD' | translate
                  }}</label>
                  <div class="partner-image-upload">
                    @if (
                      featuredImageFile &&
                      !partnerRequestForm.get('featuredImage')?.hasError('fileType')
                    ) {
                      <div class="image-preview">
                        <img [src]="featuredImageFile" alt="Featured image preview" />
                      </div>
                    }
                    @if (
                      !featuredImageFile ||
                      partnerRequestForm.get('featuredImage')?.hasError('fileType')
                    ) {
                      <div class="upload-placeholder">
                        <i class="pi pi-image"></i>
                        <span>{{ 'PARTNER_SIGNUP.NO_IMAGE' | translate }}</span>
                      </div>
                    }
                    <input
                      type="file"
                      id="featuredUpload"
                      formControlName="featuredImage"
                      accept=".jpeg,.png"
                      (change)="onFileSelected($event, 'featuredImage')"
                      hidden
                    />
                    <label for="featuredUpload" class="partner-upload-btn">
                      <i class="pi pi-upload"></i> {{ 'PARTNER_SIGNUP.UPLOAD' | translate }}
                    </label>
                  </div>
                  <small class="partner-hint-text">PNG or JPG, max 500KB</small>
                  @if (partnerRequestForm.get('featuredImage')?.hasError('fileType')) {
                    <small class="partner-error-text">
                      {{ partnerRequestForm.get('featuredImage')?.getError('fileType')?.fileType }}
                    </small>
                  }
                  @if (partnerRequestForm.get('featuredImage')?.hasError('fileSizeExceeded')) {
                    <small class="partner-error-text">
                      {{
                        partnerRequestForm.get('featuredImage')?.getError('fileSizeExceeded')
                          ?.fileSizeExceeded
                      }}
                    </small>
                  }
                </div>
              </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions two-buttons">
              <button type="button" class="btn btn-secondary" (click)="skipStep2()">
                {{ 'PARTNER_SIGNUP.BTN_SKIP_FOR_NOW' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                (click)="onSubmitStep2()"
                [disabled]="updating"
              >
                @if (updating) {
                  <i class="pi pi-spin pi-spinner"></i>
                }
                {{
                  updating
                    ? ('PARTNER_SIGNUP.BTN_SAVING' | translate)
                    : ('PARTNER_SIGNUP.BTN_SAVE_CONTINUE' | translate)
                }}
              </button>
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- Step 3: Documents (Optional) -->
      <p-stepperPanel>
        <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
          <button
            (click)="onStepHeaderClick(2, onClick)"
            class="partner-stepper-btn"
            [class.active]="activeStep === 2"
            [class.locked]="!canNavigateToStep(2)"
          >
            <span class="step-icon">
              <i class="pi pi-file"></i>
            </span>
            <span class="step-label">{{ 'PARTNER_SIGNUP.STEP_DOCUMENTS' | translate }}</span>
          </button>
        </ng-template>

        <ng-template pTemplate="content">
          <!-- Info Banner -->
          <div class="partner-info-banner">
            <i class="pi pi-info-circle"></i>
            <span>
              <strong>{{ 'PARTNER_SIGNUP.STEP3_INFO_BANNER' | translate }}</strong>
              {{ 'PARTNER_SIGNUP.STEP3_INFO_BANNER_2' | translate }}
              <strong>{{ 'PARTNER_SIGNUP.SPEED_UP_REVIEW' | translate }}</strong
              >. {{ 'PARTNER_SIGNUP.UPLOAD_LATER' | translate }}
            </span>
          </div>

          <div class="documents-section">
            <form [formGroup]="partnerRequestForm">
              <!-- Upload Documents -->
              <div class="upload-documents">
                <h4>{{ 'PARTNER_SIGNUP.UPLOAD_DOCUMENTS' | translate }}</h4>

                <div class="upload-grid">
                  <div class="upload-item">
                    <label for="commercial_license" class="upload-label">{{
                      'PARTNER_SIGNUP.COMMERCIAL_LICENSE' | translate
                    }}</label>
                    <p-fileUpload
                      #commLicUpload
                      [styleClass]="uploadedFiles['COMMERCIAL_LICENSE'] ? 'uploaded-btn' : ''"
                      inputId="commercial_license"
                      mode="basic"
                      name="COMMERCIAL_LICENSE"
                      chooseIcon="pi pi-upload"
                      chooseLabel="Upload"
                      (onSelect)="onBasicUploadAuto($event, 'COMMERCIAL_LICENSE', commLicUpload)"
                      [auto]="true"
                    >
                    </p-fileUpload>
                    @if (uploadedFiles['COMMERCIAL_LICENSE']) {
                      <div class="uploaded-file-info">
                        <i class="pi pi-file"></i>
                        <span>{{ uploadedFiles['COMMERCIAL_LICENSE'] }}</span>
                      </div>
                    }
                    <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                  </div>

                  <div class="upload-item">
                    <label for="commercial_registration" class="upload-label">{{
                      'PARTNER_SIGNUP.COMMERCIAL_REGISTRATION_EXTRACT' | translate
                    }}</label>
                    <p-fileUpload
                      #commRegUpload
                      [styleClass]="uploadedFiles['COMMERCIAL_REGISTRATION_EXTRACT'] ? 'uploaded-btn' : ''"
                      inputId="commercial_registration"
                      mode="basic"
                      name="COMMERCIAL_REGISTRATION_EXTRACT"
                      chooseIcon="pi pi-upload"
                      chooseLabel="Upload"
                      (onSelect)="
                        onBasicUploadAuto($event, 'COMMERCIAL_REGISTRATION_EXTRACT', commRegUpload)
                      "
                      [auto]="true"
                    >
                    </p-fileUpload>
                    @if (uploadedFiles['COMMERCIAL_REGISTRATION_EXTRACT']) {
                      <div class="uploaded-file-info">
                        <i class="pi pi-file"></i>
                        <span>{{ uploadedFiles['COMMERCIAL_REGISTRATION_EXTRACT'] }}</span>
                      </div>
                    }
                    <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                  </div>

                  <div class="upload-item">
                    <label for="iban_certificate" class="upload-label">{{
                      'PARTNER_SIGNUP.IBAN_CERTIFICATE' | translate
                    }}</label>
                    <p-fileUpload
                      #ibanCertUpload
                      [styleClass]="uploadedFiles['IBAN_CERTIFICATE'] ? 'uploaded-btn' : ''"
                      inputId="iban_certificate"
                      mode="basic"
                      name="IBAN_CERTIFICATE"
                      chooseIcon="pi pi-upload"
                      chooseLabel="Upload"
                      (onSelect)="onBasicUploadAuto($event, 'IBAN_CERTIFICATE', ibanCertUpload)"
                      [auto]="true"
                    >
                    </p-fileUpload>
                    @if (uploadedFiles['IBAN_CERTIFICATE']) {
                      <div class="uploaded-file-info">
                        <i class="pi pi-file"></i>
                        <span>{{ uploadedFiles['IBAN_CERTIFICATE'] }}</span>
                      </div>
                    }
                    <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                  </div>

                  <div class="upload-item">
                    <label for="civil_id" class="upload-label">{{
                      'PARTNER_SIGNUP.CIVIL_ID_COPY' | translate
                    }}</label>
                    <p-fileUpload
                      #civilIdUpload
                      [styleClass]="uploadedFiles['CIVIL_ID_COPY'] ? 'uploaded-btn' : ''"
                      inputId="civil_id"
                      mode="basic"
                      name="CIVIL_ID_COPY"
                      chooseIcon="pi pi-upload"
                      chooseLabel="Upload"
                      (onSelect)="onBasicUploadAuto($event, 'CIVIL_ID_COPY', civilIdUpload)"
                      [auto]="true"
                    >
                    </p-fileUpload>
                    @if (uploadedFiles['CIVIL_ID_COPY']) {
                      <div class="uploaded-file-info">
                        <i class="pi pi-file"></i>
                        <span>{{ uploadedFiles['CIVIL_ID_COPY'] }}</span>
                      </div>
                    }
                    <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                  </div>

                  <div class="upload-item">
                    <label for="authorized_signatory" class="upload-label">{{
                      'PARTNER_SIGNUP.AUTHORIZED_SIGNATORY_CERTIFICATE' | translate
                    }}</label>
                    <p-fileUpload
                      #authSigUpload
                      [styleClass]="uploadedFiles['MOCI_AUTHORIZED_SIGNATORIES_CERTIFICATE'] ? 'uploaded-btn' : ''"
                      inputId="authorized_signatory"
                      mode="basic"
                      name="MOCI_AUTHORIZED_SIGNATORIES_CERTIFICATE"
                      chooseIcon="pi pi-upload"
                      chooseLabel="Upload"
                      (onSelect)="
                        onBasicUploadAuto(
                          $event,
                          'MOCI_AUTHORIZED_SIGNATORIES_CERTIFICATE',
                          authSigUpload
                        )
                      "
                      [auto]="true"
                    >
                    </p-fileUpload>
                    @if (uploadedFiles['MOCI_AUTHORIZED_SIGNATORIES_CERTIFICATE']) {
                      <div class="uploaded-file-info">
                        <i class="pi pi-file"></i>
                        <span>{{ uploadedFiles['MOCI_AUTHORIZED_SIGNATORIES_CERTIFICATE'] }}</span>
                      </div>
                    }
                    <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                  </div>
                </div>

                <!-- Shareholding Company Documents -->
                <div class="shareholder-section">
                  <div class="shareholder-checkbox">
                    <input type="checkbox" id="isShareHolder" formControlName="isShareHolder" />
                    <label for="isShareHolder">{{
                      'PARTNER_SIGNUP.IS_SHAREHOLDING_COMPANY' | translate
                    }}</label>
                  </div>

                  @if (partnerRequestForm.get('isShareHolder')?.value) {
                    <div class="upload-grid">
                      <div class="upload-item">
                        <label for="board_director" class="upload-label">{{
                          'PARTNER_SIGNUP.BOARD_DIRECTOR_CERTIFICATE' | translate
                        }}</label>
                        <p-fileUpload
                          #boardDirUpload
                          [styleClass]="uploadedFiles['BOARD_DIRECTOR_CERTIFICATE'] ? 'uploaded-btn' : ''"
                          inputId="board_director"
                          mode="basic"
                          name="BOARD_DIRECTOR_CERTIFICATE"
                          chooseIcon="pi pi-upload"
                          chooseLabel="Upload"
                          (onSelect)="
                            onBasicUploadAuto($event, 'BOARD_DIRECTOR_CERTIFICATE', boardDirUpload)
                          "
                          [auto]="true"
                        >
                        </p-fileUpload>
                        @if (uploadedFiles['BOARD_DIRECTOR_CERTIFICATE']) {
                          <div class="uploaded-file-info">
                            <i class="pi pi-file"></i>
                            <span>{{ uploadedFiles['BOARD_DIRECTOR_CERTIFICATE'] }}</span>
                          </div>
                        }
                        <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                      </div>

                      <div class="upload-item">
                        <label for="shareholders_register" class="upload-label">{{
                          'PARTNER_SIGNUP.SHAREHOLDERS_REGISTER_CERTIFICATE' | translate
                        }}</label>
                        <p-fileUpload
                          #shareRegUpload
                          [styleClass]="uploadedFiles['SHAREHOLDERS_REGISTER_CERTIFICATE'] ? 'uploaded-btn' : ''"
                          inputId="shareholders_register"
                          mode="basic"
                          name="SHAREHOLDERS_REGISTER_CERTIFICATE"
                          chooseIcon="pi pi-upload"
                          chooseLabel="Upload"
                          (onSelect)="
                            onBasicUploadAuto(
                              $event,
                              'SHAREHOLDERS_REGISTER_CERTIFICATE',
                              shareRegUpload
                            )
                          "
                          [auto]="true"
                        >
                        </p-fileUpload>
                        @if (uploadedFiles['SHAREHOLDERS_REGISTER_CERTIFICATE']) {
                          <div class="uploaded-file-info">
                            <i class="pi pi-file"></i>
                            <span>{{ uploadedFiles['SHAREHOLDERS_REGISTER_CERTIFICATE'] }}</span>
                          </div>
                        }
                        <small class="partner-hint-text">{{ 'PARTNER_SIGNUP.DOCUMENT_HINT' | translate }}</small>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </form>

            <!-- Form Actions -->
            <div class="form-actions two-buttons">
              <button type="button" class="btn btn-secondary" (click)="skipStep3()">
                {{ 'PARTNER_SIGNUP.BTN_SKIP_DOCUMENTS' | translate }}
              </button>
              <button type="button" class="btn btn-primary" (click)="submitDocuments()">
                {{ 'PARTNER_SIGNUP.BTN_SUBMIT_APPLICATION' | translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </div>
</div>

<p-dialog
  [draggable]="false"
  dir="ltr"
  header="Terms of Use"
  [modal]="true"
  [(visible)]="displayDialog"
  [style]="{ width: '90vw', maxWidth: '646px' }"
  [baseZIndex]="10000"
>
  <ng-template pTemplate="header">
    <h4>{{ isTermOfUse ? ('TERM_OF_USE' | translate) : ('PRIVACY_POLICY' | translate) }}</h4>
  </ng-template>
  <ng-template pTemplate="content">
    @if (isTermOfUse) {
      <taly-terms-of-use [showHeader]="true" />
    } @else {
      <taly-privacy-policy />
    }
  </ng-template>
</p-dialog>
